
export default {
    props: {
        dialog: {
            type: Boolean,
            default: false,
            required: true
        }
    },
    emits: ['close'],
    data() {
        return {
            // input data
            jsonData:
                '[{"name":"Username", "phone":"+7-123-456-78-90", "email":"user1@mail.ru", "birthday":"01.01.2000"}]',

            // input rules
            jsonDataRules: [
                (val: string) => !!(val && val.trim()) || this.$t('dialogs.import.errors.required'),
                (val: string) => this.isValidJSON(val) || this.$t('dialogs.import.errors.invalid')
            ]
        };
    },
    computed: {
        hasEnteredData() {
            return !!this.jsonData;
        }
    },
    methods: {
        // TODO: check validation
        isValidJSON(value: string) {
            try {
                const o = JSON.parse(value);
                return !!o && typeof o === 'object';
            } catch {
                return false;
            }
        },
        async importContacts() {
            try {
                const message = await this.$store.dispatch('contacts/importContacts', JSON.parse(this.jsonData));
                this.$store.dispatch('snackbar/showSnackbar', { message, type: 'success' });
            } catch (error) {
                this.$store.dispatch('snackbar/showSnackbar', { message: error.message, type: 'failure' });
            }
            this.closeModal();
        },
        closeModal() {
            this.setOriginalData();
            this.$emit('close');
        },
        setOriginalData() {
            this.jsonData =
                '[{"name":"Username", "phone":"+7-123-456-78-90", "email":"user1@mail.ru", "birthday":"01.01.2000"}]';
        }
    }
};
